import { Link } from 'react-router-dom';

/**
 * Marketing cream auth shell — thin Inter, pill CTAs via children.
 * Uses `.theme-marketing` so auth shares public texture tokens.
 */
const AuthPage = ({ children }) => (
  <div className="theme-marketing marketing-app flex min-h-screen flex-col bg-m-canvas-light">
    <header className="flex h-[4.25rem] items-center justify-center border-b border-black bg-black">
      <Link to="/" className="flex items-center justify-center">
        <img
          src="/images/VendaLOGO1.png"
          alt="VendaList"
          className="h-11 w-auto"
        />
      </Link>
    </header>
    <main className="flex flex-1 items-center justify-center px-4 py-12 sm:py-16">
      <div className="w-full max-w-md">{children}</div>
    </main>
  </div>
);

export default AuthPage;
